import React from "react";

import Footer from "../components/footer";

const EmptyLayout = ({ children }) => {
    return (
        <div>
            {children}
            <Footer />
        </div>
    );
};

export default EmptyLayout;
